import React from 'react'
import {Row,Col} from 'react-bootstrap'
import { useSelector} from "react-redux"

const ListaStart = () => {
    const listastart = useSelector((magazyn) => magazyn.start)
        return(
            <Row>
            <Row> 
                <Col xs={12}><h2> Rozpoczęcie Testu </h2></Col>
            </Row>
            <Row> 
                <Col xs={1}></Col>   
                <Col xs={11}>
                <ol key="666" className='font-regulamin'>
                  {listastart.map(pozycja => (
                      <li key={pozycja.lp}>{pozycja.tekst}</li>
              ))
             }
             </ol>
             </Col>
            </Row> 
            </Row>  
        )
}

export default ListaStart